import axios from 'axios';

// Crie uma instância do Axios com a URL base
const api = axios.create({
  baseURL: 'https://gnunef.ddns.com.br:7656/api', // URL base da sua API
});

// Interceptor para adicionar o token ao cabeçalho
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token'); // Obtém o token do localStorage
  
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`; // Adiciona o token no cabeçalho
  }
  
  return config;
}, error => {
  return Promise.reject(error);
});

export default api;
